
import store from '@/store';

export default {
  props: {
    processingUserDataRequest: Boolean,
    lackOfFullAccess: Boolean,
    onboardedFully: Boolean,
    subscriptionStatusAllowsToUseTheApp: Boolean,
    verified: Boolean,
    allowedToMatch: Boolean,
    canShowCompletionSteps: Boolean,
  },

  data(): Record<string, unknown> {
    return {
      showAsAPartOfProfile: false,
      userRole: store.state.userRole,
      completionStepsNotification: '',
      htmlStringFullyOnboardedAssessor: `
      <br />
      <div>
        <div>
          <i class="fas fa-dot-circle"></i> <strong>${this.$t(
            'userProfileCompletionStepsCopy2',
          )}</strong>
        </div>
        <small>
          ${this.$t('userProfileCompletionStepsCopy5Assessor')}
        </small>
      </div>
      `,

      htmlStringFullyOnboardedClient: `
      <br />
      <div>
        <div>
          <i class="fas fa-dot-circle"></i> <strong>${this.$t(
            'userProfileCompletionStepsCopy2',
          )} & ${this.$t('company')}</strong>
        </div>
        <small>
          ${this.$t('userProfileCompletionStepsCopy5Client')}
        </small>
      </div>
      `,

      htmlStringValidSubscription: `
      <br />
      <div>
        <div>
          <i class="fas fa-dot-circle"></i> <strong>${this.$t(
            'userProfileCompletionStepsCopy4',
          )}</strong>
        </div>
        <small>
          ${this.$t('waitForFreeAccessOrUseATrial')}
        </small>
      </div>
      `,

      htmlStringAllowedToMatch: `
      <br />
      <div>
        <div class="user-profile-completion-steps__heading">
          <i class="fas fa-dot-circle"></i> <strong>${this.$t('businessCriteria')} ${this.$t(
        'and',
      )} ${this.$t('matchingInformation')}</strong>
        </div>
        <small class="user-profile-completion-steps__hint">
          ${this.$t('notAllowedToMatch')}
        </small>
      </div>
      `,

      htmlStringVerified: `
      <hr />
      <div class="verification-checks">
        <div>
          <div class="user-profile-completion-steps__heading">
            <i class="fas fa-dot-circle"></i> <strong>${this.$t(
              'userProfileCompletionStepsCopy6',
            )}</strong>
          </div>
          <small class="user-profile-completion-steps__hint">
            ${this.$t('userProfileCompletionStepsCopy7')}
          </small>
        </div>
      </div>
      <br />
      `,
    };
  },

  computed: {
    showMe(): boolean {
      return this.lackOfFullAccess && this.canShowCompletionSteps && this.showAsAPartOfProfile;
    },

    assessorCanFillMissingData(): boolean {
      return this.userRole === 'assessor' && (!this.allowedToMatch || !this.onboardedFully);
    },

    clientCanFillMissingData(): boolean {
      return (
        this.userRole === 'client' &&
        (!this.subscriptionStatusAllowsToUseTheApp || !this.onboardedFully)
      );
    },

    showCompletionStepsInfo(): boolean {
      if (!this.canShowCompletionSteps) return;

      return this.assessorCanFillMissingData || this.clientCanFillMissingData;
    },

    htmlStringFinalMessage(): string {
      // Hidden for now, we might have to restore it later with different copy
      // ${!this.onboardedFully && this.userRole === 'assessor' ? this.htmlStringFullyOnboardedAssessor : ''}
      // ${!this.onboardedFully && this.userRole === 'client' ? this.htmlStringFullyOnboardedClient : ''}

      return `
      ${
        !this.onboardedFully && this.userRole === 'client'
          ? this.htmlStringFullyOnboardedClient
          : ''
      }
      ${
        !this.subscriptionStatusAllowsToUseTheApp && this.userRole === 'client'
          ? this.htmlStringValidSubscription
          : ''
      }
      ${!this.allowedToMatch && this.userRole === 'assessor' ? this.htmlStringAllowedToMatch : ''}
      ${!this.verified ? this.htmlStringVerified : ''}
      `;
    },
  },

  watch: {
    canShowCompletionSteps(): void {
      if (this.canShowCompletionSteps && this.lackOfFullAccess) this.displayNotificationWithSteps();
    },

    onboardedFully(): void {
      this.closeAndReopenNotification(this.onboardedFully);
    },

    subscriptionStatusAllowsToUseTheApp(): void {
      this.closeAndReopenNotification(this.subscriptionStatusAllowsToUseTheApp);
    },

    allowedToMatch(): void {
      this.closeAndReopenNotification(this.allowedToMatch);
    },

    verified(): void {
      this.closeAndReopenNotification(this.verified);
    },
  },

  methods: {
    displayNotificationWithSteps(): void {
      if (
        this.completionStepsNotification.visible ||
        document.querySelector('.completion-steps-notification')
      )
        return;

      this.completionStepsNotification = this.$notify.warning({
        title: this.$t('userProfileCompletionStepsCopy1'),
        dangerouslyUseHTMLString: true,
        message: this.htmlStringFinalMessage,
        offset: 120,
        duration: 0,
        customClass: 'completion-steps-notification',
      });
    },

    closeAndReopenNotification(completionStepDone: boolean): void {
      if (completionStepDone && this.lackOfFullAccess) {
        if (this.completionStepsNotification.visible) this.completionStepsNotification.close();

        setTimeout(() => {
          this.displayNotificationWithSteps();
        }, 200);
      }
    },
  },
};
